var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVagoSujo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-vago-sujo",
    transform: "translate(-848 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2632",
    "data-name": "Rectangle 2632",
    transform: "translate(848 250)",
    fill: "#24272a",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M15.7,2.72l1.115,1.115-4.49,4.482a3.125,3.125,0,0,1,.251,3.6L7.617,6.959a3.125,3.125,0,0,1,3.6.251L15.7,2.72M5.16,14.377a9.651,9.651,0,0,1-2.81-5.22L6.181,7.516l5.84,5.84L10.38,17.187A9.651,9.651,0,0,1,5.16,14.377Z",
    transform: "translate(847.516 248.946)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVagoSujo);
export default __webpack_public_path__ + "static/media/icon-vago-sujo.08f602592bbbb41e8c5e915b603b3d2a.svg";
export { ForwardRef as ReactComponent };